import Vue from 'vue'
import VueI18n from 'vue-i18n'
import I18nUtil from '@didi/i18n-util'
import { i18nInit, i18nGet } from '@didi/i18n-plugin'

// 语言包
import zhCN from './zh-CN'
import enUS from './en-US'
import ptBR from './pt-BR'
import esMX from './es-MX'
import es419 from './es-419'
import xss from 'xss'

const { getLanguage } = I18nUtil
i18nInit(require('./i18n-info'))

const lang = getLanguage().long

Vue.use(VueI18n)

// 预处理翻译文本，将{{{variable}}}转换为{variable}，同时处理{{variable}}格式
function preprocessMessages(messages) {
  const processed = {}
  // 使用 Object.keys() 替代 Object.entries() 以兼容 Chromium 50
  for (const key of Object.keys(messages)) {
    const value = messages[key]
    if (typeof value === 'string') {
      let str = xss(value)
      // 1. 将 {{{variable}}} 转换为 {variable} (供i18n组件使用)
      str = str.replace(/{{{([^{}]+)}}}/g, '{$1}')
      // 2. 处理 {{variable}} 格式的变量替换 (供$t()使用)
      str = str.replace(/\{\{([^{}]+)\}\}/g, '{$1}')
      processed[key] = str
    } else {
      processed[key] = value
    }
  }
  return processed
}

// vue-i18n的8.x版本初始化方式
export default new VueI18n({
  locale: lang, // 设置地区，根据项目自定设定
  // formatter: new CustomFormatter(),
  messages: {
    'en-US': preprocessMessages(i18nGet(enUS, 'en-us')),
    'zh-CN': preprocessMessages(i18nGet(zhCN, 'zh-cn')),
    'pt-BR': preprocessMessages(i18nGet(ptBR, 'pt-br')),
    'es-MX': preprocessMessages(i18nGet(esMX, 'es-mx')),
    'es-419': preprocessMessages(i18nGet(es419, 'es-419')),
  },
})
